exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal_content[data-v-6df86697]{border:1px solid #c9e4ff!important;border-radius:8px!important;width:100%}.modal_content .modal_header .modal_title[data-v-6df86697]{font-family:Lato;font-weight:700;font-size:29px;text-transform:uppercase;color:#a5b9d5}.modal_content .modal_header .subtitile_box[data-v-6df86697]{padding:.5rem 1rem!important;width:100%!important;background:#e9edf2!important;border-radius:5px!important}.modal_content .modal_header .subtitile_box .modal_subtitle[data-v-6df86697]{font-family:Lato;font-weight:700;font-size:15px;text-transform:uppercase;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#a5b9d5}.modal_content .modal-body[data-v-6df86697]{padding:2rem 0 0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6df86697","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/franchise_v4/modals/Autoresponder.vue
// module id = ENMo
// module chunks = 0